import Repository from './Repository';

const resource = '/liff';

export default {
  /**
   * LIFFで得たidTokenを元にサーバーサイドで顧客を特定し、セッションを確立する
   * @param idToken
   * @param gwKey 流入経路分析用(ゲートウェイ)キー
   * @see https://developers.line.biz/ja/reference/liff/#get-id-token
   */
  login(
    idToken: string,
    gwKey: string | null
  ): Promise<{
    customer: {
      id: string;
      registered: boolean;
      isRegistrationRequired: boolean;
      isPolicyConsentRequired?: boolean;
      surveyUrl: string;
    };
  }> {
    return Repository.post(`${resource}/login`, { idToken, gwKey });
  },
};
